import React from 'react'
import styled from 'styled-components'
import Image from '../../components/Image/Image'

const StyledHeader = styled.div`
  width: 100%;
  background: #417799;
  max-height: 30rem;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
  ${props => props.isTablet && 'max-height: 25rem'}
`

const EverydaySaveHeader = ({ logo, isTablet }) => {
  return (
    <StyledHeader isTablet={isTablet}>
      <Image src={logo} alt="" />
    </StyledHeader>
  )
}
export default EverydaySaveHeader
